'use client';

import CenteredMain from '@/components/CenteredMain';
import DontHaveAnAccount from '@/components/DontHaveAnAccount';
import FixedTopRight from '@/components/FixedTopRight';
import NeedHelpText from '@/components/NeedHelpText';
import SignIn from '@/components/SignIn';
import ThemedPage from '@/components/ThemedPage';

export default function LoginPageContents() {
  return (
    <ThemedPage>
      <FixedTopRight>
        <DontHaveAnAccount />
      </FixedTopRight>
      <CenteredMain>
        <SignIn />
        <NeedHelpText />
      </CenteredMain>
    </ThemedPage>
  );
}
